import Swiper from 'swiper/js/swiper.min'

export class Slider {

    constructor(target = '.js-slider', options = {}) {

        this.target = target;

        this.options = {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoHeight: true,
            startAt: 0,
            slidesPerView: 1,
            slideClass: 'js-slider__slide',
            wrapperClass: 'js-slider__track',
            slideActiveClass: 'js-slider__slide--active',
            noSwipingClass: 'js-slider__no-swipe',
            ...options
        }

        this.observerOptions = {
            observer: {
                root: document.querySelector('body'),
                rootMargin: '0px',
                threshold: 0.01
            },
            removeTarget: true,
            ...options
        }
    }

    init() {

        this.sliders = [];
        this.el = Array.from(document.querySelectorAll(this.target));

        if (this.el.length > 0) {
            this.sliderObserver = new IntersectionObserver((entries, observer) => {
                this.create(entries, this)
            }, this.options);

            this.el.forEach($el => {
                this.sliderObserver.observe($el);
            });
        }

    }

    create(entries, instance) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {

                const $el = entry.target;
                const count = Array.from($el.querySelectorAll(`.${this.options.slideClass}`)).length;

                let options = {
                    ...this.options,
                }

                const $pages = $el.querySelector(`.c-slider__pagination`);
                const $controls = $el.querySelector(`.c-slider__controls`);
                const autoplay = $el.dataset.autoplay;
                const crossfade = $el.dataset.crossfade;

                if (crossfade == 'hide') {
                    options = {
                        ...options,
                        fadeEffect: {
                            crossFade: false
                        },
                    }
                }

                if (autoplay) {
                    options = {
                        ...options,
                        autoplay: {
                            delay: parseInt(autoplay),
                        },
                        pagination: {
                            el: '.c-slider__progression',
                            clickable: true,
                            renderBullet: function (index, className) {
                                return `<span class="c-slider__progress ${className}" style="animation-duration: ${autoplay}ms"></span>`;
                            },
                        }
                    }
                }

                if (count > 1) {
                    if ($pages) {
                        options = {
                            ...options,
                            pagination: {
                                type: 'bullets',
                                el: '.c-slider__pagination',
                                bulletClass: 'c-slider__bullet',
                                hiddenClass: 'c-slider__pagination--hidden',
                                bulletActiveClass: 'c-slider__bullet--active',
                                clickable: true
                            },
                        }
                    }

                    if ($controls) {
                        options = {
                            ...options,
                            navigation: {
                                nextEl: '.js-slider__button--next',
                                prevEl: '.js-slider__button--prev',
                                disabledClass: 'c-slider__button--disabled'
                            },
                        }
                    }
                } else {

                    if ($pages) {
                        $pages.remove();
                    } else if ($controls) {
                        $controls.remove();
                    }
                }

                const swiper = new Swiper($el, options);

                if (autoplay) {
                    this.sliders.push(swiper);
                    const $progress =  $el.querySelector('.c-slider__progression');

                    swiper.on('activeIndexChange', function () {
                        setTimeout( () => {
                            if(!swiper.autoplay.running) {
                                $progress.classList.add('c-slider__progression--halt');
                            }
                        }, 100)
                    })
                }
                instance.sliderObserver.unobserve($el);
            }
        })
    }

    destroy() {
        if (this.el.length > 0) {
            this.sliderObserver.disconnect();
        }
        this.sliders.forEach(slider => {
            slider.destroy();
        })
    }
}
